import {
  MembersSortBy,
  MembersSortDir,
  WorkspaceRole,
} from '../../../api/workspaces/getWorkspaceMembers';

export const workspaceKeys = {
  all: ['workspaces'] as const,
  list: () => [...workspaceKeys.all, 'list'] as const,
  byId: (workspaceId: string) => [...workspaceKeys.all, workspaceId] as const,
  details: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'details'] as const,
  settings: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'settings'] as const,
  allQuizzes: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'quizzes'] as const,
  quizzes: ({
    workspaceId,
    isDeleted = false,
  }: {
    workspaceId: string;
    isDeleted?: boolean;
  }) =>
    [
      ...workspaceKeys.allQuizzes(workspaceId),
      { isDeleted: isDeleted },
    ] as const,
  allFolders: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'folders'] as const,
  folders: ({
    workspaceId,
    isDeleted = false,
  }: {
    workspaceId: string;
    isDeleted?: boolean;
  }) =>
    [
      ...workspaceKeys.allFolders(workspaceId),
      { isDeleted: isDeleted },
    ] as const,
  members: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'members'] as const,
  membersSorted: ({
    workspaceId,
    sortBy,
    sortDir,
    search,
  }: {
    workspaceId: string;
    sortBy: MembersSortBy;
    sortDir: MembersSortDir;
    search?: string;
  }) =>
    [
      ...workspaceKeys.members(workspaceId),
      { sortBy, sortDir, search: search || '' },
    ] as const,
  member: (workspaceId: string) => [
    ...workspaceKeys.byId(workspaceId),
    'requestingUserRole',
  ],
  allCodes: (workspaceId: string) =>
    [...workspaceKeys.byId(workspaceId), 'code'] as const,
  codeStatuses: (workspaceId: string) =>
    [...workspaceKeys.allCodes(workspaceId), 'statuses'] as const,
  codeByWorkspaceRole: ({
    workspaceId,
    workspaceRole,
  }: {
    workspaceId: string;
    workspaceRole: WorkspaceRole;
  }) => [...workspaceKeys.allCodes(workspaceId), workspaceRole] as const,
  byWorkspaceQuizId: ({
    workspaceId,
    workspaceQuizId,
  }: {
    workspaceId: string;
    workspaceQuizId: string;
  }) => [...workspaceKeys.byId(workspaceId), 'quiz', workspaceQuizId] as const,
  quizLock: ({
    workspaceId,
    workspaceQuizId,
  }: {
    workspaceId: string;
    workspaceQuizId: string;
  }) =>
    [
      ...workspaceKeys.byWorkspaceQuizId({
        workspaceId,
        workspaceQuizId,
      }),
      'lock',
    ] as const,
};
